import { inject, Injectable } from '@angular/core'

import { ApiService } from '@ti/core/api'
import { NewPasswordViewModel } from '@ti/shared/auth-ui/models'

@Injectable()
export class AdminNewPasswordViewModel extends NewPasswordViewModel {
  protected readonly api = inject(ApiService)

  protected async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await this.api.ti.user.changePassword(currentPassword, newPassword)
  }

  protected async confirmPasswordReset(password: string, secret: string): Promise<void> {
    await this.api.ti.user.confirmPasswordReset(password, secret)
  }
}
